/**
 * Adebify table dimension columns that use detail-analysis ellipsis + hover tooltip.
 *
 * Matches COLUMN_NOWRAP_WITH_TOOLTIP behaviour: overflow hidden with "..." and
 * full text on mouseover via CellContentWrapper.
 */

/** API / header field keys for adebify dimension columns. */
export const ADEBIFY_DIMENSION_TOOLTIP_FIELDS = [
  'channel_type',
  'media',
  'media_type',
  'media_campaign',
  'media_ad_group',
  'media_ad_id',
  'media_ad_name',
  'ad_group1',
  'ad_group2',
  'ad_id',
  'ad_name',
  'remarks',
  'posting_period',
  'device',
  'lp_domain',
  'lp_url',
  'product_category',
  'product_name',
  'product_variant',
  'purchased_product',
  'purchased_variant',
  'purchased_product_id',
  'purchased_variant_id',
  'purchased_product_category',
  'ad_product_name',
  'ad_product_category',
  'ad_product_variant',
  'dimension_value',
];

/** Legacy cell keys written by normalizeAdebifyTableRow (tableRowNormalizer). */
export const ADEBIFY_LEGACY_CELL_FIELD_KEYS = [
  'ad_group1_name',
  'ad_group2_name',
  'media_side_campaign_name',
  'media_side_group_name',
  'media_side_ad_name',
];
